import { createFileRoute } from "@tanstack/react-router";
import { AboutHeroSection } from "@/components/marketing/sections/about-hero-section";
import { AboutSection } from "@/components/marketing/sections/about-section";
import { ApproachSection } from "@/components/marketing/sections/approach-section";
import { AccessibilitySection } from "@/components/marketing/sections/accessibility-section";
import { PartnersSection } from "@/components/marketing/sections/partners-section";
import { TestimonialSection } from "@/components/marketing/sections/testimonial-section";

export const Route = createFileRoute("/_marketing/about")({
  component: About,
});

function About() {
  // Grounds alternate white / surface after the teal hero, then the navy testimonial; the layout's Footer adds the newsletter.
  return (
    <>
      <AboutHeroSection />
      <AboutSection />
      <ApproachSection />
      <AccessibilitySection layout="split" />
      <PartnersSection />
      <TestimonialSection />
    </>
  );
}
